<template>
    <div class="swiper goalSlider !px-8">
        <div class="swiper-wrapper">

            <div 
                @click="() => $router.push({name : 'adminAnalyticsGoal'})" 
                v-for="(goal, i) in modifiedGoals" :key="i" 
                :class="[{'bg-gray' : isAdminView}, {'bg-white' : !isAdminView}]"
                class="swiper-slide rounded-lg !w-[18.75rem] min-h-20  p-3">
                <div class="text-sm text-gray-1">Goal {{i+1}}</div>

                <div class="grid grid-cols-3 content-center">
                    <div v-node="renderGoalDoughnutChart(goal)"></div>
                    <div class="col-span-2 flex flex-col justify-center pl-4">
                        <h1 class="text-xl leading-none font-bold">{{goal?.goal?.post_title || ''}}</h1>
                        <p class="mb-0 text-sm text-gray-1">{{completedTask(goal)}}/{{ goal?.tasks?.length || 0 }} Complete</p>
                    </div>
                </div>
            </div>

            <div 
                v-if="modifiedGoals.length == 0" @click="() => $router.push({name : 'adminAnalyticsGoal'})" 
                class="swiper-slide rounded-lg !w-[18.75rem]   bg-gray p-3"
                :class="[{'isLoading' : isLoading}, {'bg-white' : !isLoading}]"
                >
                <div class="text-sm text-gray-1">Goal </div>

                <div class="border border-gray !border-dashed h-full flex items-center justify-center !h-[6rem]">
                    <church-icon icon="plus"></church-icon>
                </div>
            </div>
          
        </div>
    </div>
</template>

<script setup>

/* Utils */
import Swiper from 'swiper';
import { computed, onBeforeMount, ref, watch, defineEmits } from "vue";
import Charts from '@/helpers/charts';
import _ from 'lodash'
// import Helper from '@/helpers/helpers';
import store from '@/store';
import GoalApis from '@/apis/goalApis';
import ColorUtils from '@/helpers/colorUtils';
import router from '@/router';


    /*  ========= STATEs ===== */
    const goalSlider      = ref(null)
    // const currentUserType = ref(Helper.getCookie('stakeUserType'))
    const goalList        = ref([])
    const isLoading       = ref(false)
    const route = router?.app?._route || null

    /* ========== EMITs ======== */
    const emit = defineEmits(['goals'])

    /** ============ COMPUTED ======== */
    /**
     * Current user 
     */
    const currentUser = computed(() => store.state?.user?.user_info || null)

    /**
     * Modified Goal List
     */
    const modifiedGoals = computed(() => {
        const list = [...goalList.value?.goals || []].map(goal => {
            return {
                ...goal,
                tasks : goal?.goal_field_ojects?.tasks?.value || [],
                users : goal?.goal_field_ojects?.assign_to || []
            }
        })
        

        return list;
    })


    /**
     * Check if admin view or normal user view
     */
    const isAdminView = computed(() => {
        return route?.name == 'adminDashboard' ? true : false
    })


    /* ================== METHODS ========= */

    /**
     * Completed tasks
     * @param {Object} goal
     */
    const completedTask = (goal) => {
        return goal?.tasks?.filter(task => task.is_completed).length
    }
    

    /**
     * Get admin goal list
     * 
     */
    const getAdminGoalList =  async () => {
        isLoading.value = true;
        console.log(currentUser.value?.ID, 'currentUser.value', currentUser.value)

        // if(currentUserType.value != 'administrator') return;// prevent if not admin
        if(!currentUser.value?.ID) return ; // prevent if no current user

        let goals = {goals : []}

        await GoalApis.getAllGoals({user_id : currentUser.value?.ID, callback : res => {
            goals = res
        }})

        await GoalApis.getUserOwnedGoals({user_id : currentUser.value?.ID, callback : res => {
            console.log('user owened goals', res)
            goals.goals = [...goals.goals, ...res.goals].filter((a, b, c) => c.findIndex(d => d?.goal?.ID == a?.goal?.ID) == b); // remove duplicate
        }})

        goalList.value = goals

         /* Init goal slider */
        initGoalSlider();

        /* Emit to parent  */
        emit('goals', goals)

        isLoading.value = false;


    }

    /**
     * Render goals doughnut chart
     * @param {Object} goal
     */
    const  renderGoalDoughnutChart = (goal) => {
        const data = {
            a : goal?.tasks?.length - goal?.tasks?.filter(task => task.is_completed).length,
            b : goal?.tasks?.filter(task => task.is_completed).length
        }


        return Charts.doughnutChart({
            width           : 200,
            height          : 200,
            valueColor      : ColorUtils.randomColor(),
            radiusWidth     : 15,
            radius          : 70,
            centerText      : false,
            placeholderColor: '#DEE0ED',
            data,
        })
    }


    /**
     * Init Goal Slider
     */
    const initGoalSlider =  _.debounce(function()   {
        goalSlider.value = new Swiper('.goalSlider', {
            slidesPerView: 'auto',
            spaceBetween : 10
        })

        console.log('goalSlider.value', goalSlider.value)
    }, 100)



    /** =============== WATCHER ====== */
    /**
     * Watch current user changes and load function that required current user
     */
     watch(() => currentUser, (user) => {
        if(!user.value?.ID) return;

        /**
         * Get goal list 
         */
         getAdminGoalList()
    }, {deep : true})

    /* Onload */
    onBeforeMount(() => {
        /* Get goal list */
        getAdminGoalList();
       
    })
</script>